// extracted by mini-css-extract-plugin
export default {"layoutLeft":"TableLeftTemplate_layoutLeft__FjHrv","left":"TableLeftTemplate_left__7+NF3","main":"TableLeftTemplate_main__slyJu"};